import { BASE_PATHS, PATHS } from '@belong/common';
import { Image, Link, Text } from '@belong/ui';
import clsx from 'clsx';
import { BLOG_STRINGS } from '../../blog.strings';
import css from './homeowners-widget.module.css';

type Props = {
  ctaRef: React.RefObject<HTMLAnchorElement>;
  title?: string;
  primaryCta?: string;
  primaryHref?: string;
  secondaryCta?: string;
  secondaryHref?: string;
};

export function HomeownersWidget({
  ctaRef,
  title,
  primaryCta,
  primaryHref,
  secondaryCta,
  secondaryHref,
}: Props) {
  return (
    <div
      className={clsx(
        css.container,
        'border-gray px-2sm pb-xl pt-md flex flex-col items-center rounded border border-solid bg-white',
      )}
    >
      <div className={css.imgContainer}>
        <Image src="/blog/belong_blog_banner.png" alt="" />
      </div>
      <div className="mb-lg">
        <Text fontWeight="semibold" className="whitespace-pre-line text-center">
          {title || BLOG_STRINGS['hoWidget.title']}
        </Text>
      </div>
      <div className="mb-sm">
        <Link
          ref={ctaRef}
          variant="solid"
          size="large"
          href={primaryHref || BASE_PATHS.HOMEOWNER}
        >
          {primaryCta || BLOG_STRINGS['hoWidget.cta1label']}
        </Link>
      </div>
      <Link href={secondaryHref || PATHS.HOMEOWNER_ONBOARDING_PROPERTY_ADDRESS}>
        {secondaryCta || BLOG_STRINGS['hoWidget.cta2label']}
      </Link>
    </div>
  );
}
